<template>
    <div class="app-container">
        <div class="teamShop-detail">
            <!-- 商品预览图与活动时间 -->
            <div class="goods-box">
                <div>
                    <img class="goods-img" :src="goods_info.pic">
                </div>
                <div class="goods-box-banner">
                    <div class="banner-price-box">
                        <span>￥</span>
                        <div class="banner-price">{{ goods_info.unitPrice }}</div>
                        <div>
                            <div :style="{ fontSize: '20px', fontWeight: '400' }">团购价</div>
                            <div>元 / 样</div>
                        </div>
                        <span :style="{ marginLeft: '40px' }">历 史 底 价</span>
                    </div>
                    <div class="banner-info-box">
                        <span>仅限 {{ goods_info.samples }}样</span>
                        <span>原价 ￥{{ goods_info.originalPrice }}元/样</span>
                        <div class="info-box-tag">立省 {{ goods_info.originalPrice - goods_info.unitPrice }}元</div>
                    </div>
                    <div class="banner-time-box">
                        <div class="time-box-day">
                            <span v-if="goods_info.activityStatus == '未开始'">离活动开始还有</span>
						    <span v-if="goods_info.activityStatus == '进行中'">离活动结束还有</span>
						    <span v-if="goods_info.activityStatus == '已结束'" class="activity-end">活动已结束</span>
                            <span v-if="goods_info.activityStatus != '已结束'" :style="{ color: '#E20D3D' }">{{ day }}</span>
                            <span v-if="goods_info.activityStatus != '已结束'">天</span>
                        </div>
                        <div v-if="goods_info.activityStatus != '已结束'" class="time-box-h">
                            <div class="time-box-item">{{ hours }}</div>
                            <span class="time-box-icon">:</span>
                            <div class="time-box-item">{{ minutes }}</div>
                            <span class="time-box-icon">:</span>
                            <div class="time-box-item">{{ seconds }}</div>
                        </div>
                    </div>
                    <img class="banner-bg" src="http://pstatic.navi-sci.cn/groupact/teamShop_detail_1.png">
                </div>
            </div>
            <!-- 商品信息 -->
            <div class="goods-info">
                <div class="pay-tips">
                    <div class="pay-tips-icon">
                        <img src="http://pstatic.navi-sci.cn/groupact/teamShop_detail_3.png">
                    </div>
                    <div>先测后付</div>
                    <div class="pay-tips-box"></div>
                    <div>支持0元检测，确认结果后再付款</div>
                </div>
                <div class="goods-name">{{ goods_info.equipmentName }}</div>
                <div class="goods-num">
                    <div class="goods-num-top">
                        <span>团购价￥</span>
                        <span class="goods-num-price">{{ goods_info.unitPrice }}</span>
                        <span>元/样</span>
                    </div>
                    <div class="goods-num-bottom">
                        <span>样品 {{ goods_info.samples }}</span>
                        <span>已收样 {{ goods_info.revceivedSamples || 0 }}</span>
                    </div>
                </div>
                <div class="invite-box">
                    <div class="box-icon">拼</div>
                    <div>邀请用户，一起拼单凑样，享超低价！</div>
                </div>
                <div class="tag-box">
                    <div class="goods-tag">历史低价</div>
                    <div class="goods-tag">不成团包退</div>
                    <div class="goods-tag">2个工作日出结果</div>
                </div>
                <div class="team-rule-box">
                    <span>拼团规则</span>
                    <img src="http://pstatic.navi-sci.cn/groupact/teamShop_detail_4.png" alt="">
                </div>
                <div v-if="!goods_info.clientStatus">
                    <div v-if="goods_info.activityStatus == '进行中'" class="teamShop-button" @click="openQRcodeBox('pages/index/index',400,detailId)">立即拼团</div>
                    <div v-else class="teamShop-button active-end">立即拼团</div>
                </div>
                <div v-else>
                    <div v-if="goods_info.clientStatus == 1">
                        <div class="teamShop-button" @click="openQRcodeBox('pages/index/index',400,detailId)">还差 <span class="teamShop-button-text">{{ goods_info.samples - goods_info.revceivedSamples }}</span> 样开团，邀请好友参团</div>
                    </div>
                    <div v-if="goods_info.clientStatus == 2">
                        <div class="teamShop-button active-end">拼团成功，待确认</div>
                    </div>
                    <div v-if="goods_info.clientStatus == 3">
                        <div class="teamShop-button" @click="openQRcodeBox('pages/order/index',400,'-')">拼团成功 查看订单</div>
                    </div>
                    <div v-if="goods_info.clientStatus == 4">
                        <div class="teamShop-button active-end">订单已被取消</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 活动须知 -->
        <div class="active-notices">
            <div class="active-notices-title">
                <span class="title-icon"></span>
                <span>活动须知</span>
            </div>
            <div class="notices-info" v-html="goods_info.equipmentRemark"></div>
        </div>
        <!-- 二维码弹窗 -->
        <div v-if="openQRcode" class="QRcode-box">
            <div class="QRcode-box-content">
                <img src="https://pstatic.navi-sci.cn/groupact_new/pc_teamShop_QrCode_20241216" alt="">
                <i class="el-icon-close" @click="openQRcode = false"></i>
                <div class="QRcode-main">
                    <img :src="QRCode_main">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getTeamShopDetail, getQRcode } from '@/api/request'
import { timeFormat } from '@/utils/timeFormat'
export default {
    data() {
        return {
            openQRcode: false,
            QRCode_main: null,
            activityEquipmentId: null,
			detailId: null,
			activityId: null,//活动id
			goods_info: {},//活动商品详细信息
            countdown: null,
			day: '--',
			hours: '--',
			minutes: '--',
			seconds: '--',
        };
    },
    created() {
        let timer = null
        getTeamShopDetail(this.$route.query.activityEquipmentId).then(res=>{
            this.goods_info = res.data
			this.activityId = res.data.activityId
			this.detailId = res.data.detailId
            this.countdown = res.data.countdown
            this.day = timeFormat(this.countdown).day
			this.hours = timeFormat(this.countdown).hours
			this.minutes = timeFormat(this.countdown).minutes
			this.seconds = timeFormat(this.countdown).seconds
            if(this.countdown != 0) {
                timer = setInterval(() => {
                    if(this.countdown <= 1) {
                        clearInterval(timer)
                    }
			        this.countdown -= 1
			        this.day = timeFormat(this.countdown).day
			        this.hours = timeFormat(this.countdown).hours
			        this.minutes = timeFormat(this.countdown).minutes
			        this.seconds = timeFormat(this.countdown).seconds
			    }, 1000);
            }
        })
    },
    methods: {
        // 生成跳转小程序的二维码
        openQRcodeBox(path,width,scene) {
            this.openQRcode = true
            getQRcode(path,width,scene).then(res=>{
                this.QRCode_main = 'data:image/png;base64,' + res.qrCodeBytes
            })
        }
    },
};
</script>

<style lang="scss" scoped>
.app-container {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    background-color: #F8F8FA;
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
}

.teamShop-detail {
    display: flex;
    width: 2020px;

    .goods-box {
        .goods-img {
            width: 1000px;
        }

        .goods-box-banner {
            position: relative;
            color: #ffffff;

            .banner-bg {
                width: 1000px;
            }

            .banner-price-box {
                position: absolute;
                top: 10px;
                left: 30px;
                display: flex;
                align-items: flex-end;
                font-size: 40px;

                .banner-price {
                    position: relative;
                    top: 10px;
                    margin: 0 10px;
                    font-size: 70px;
                    font-weight: 800;
                }
            }

            .banner-info-box {
                position: absolute;
                bottom: 30px;
                left: 30px;
                display: flex;
                justify-content: space-between;
                width: 580px;
                color: #ffffff;
                font-size: 30px;

                .info-box-tag {
                    padding: 0 20px;
                    color: #F81531;
                    border-radius: 20px;
                    background: linear-gradient(to bottom, #FFF0CD, #F7DA72);
                }
            }

            .banner-time-box {
                position: absolute;
                top: 40px;
                left: 670px;
                font-weight: 800;

                .time-box-day {
                    display: flex;
                    justify-content: space-between;
                    width: 300px;
                    color: #2E2321;
                    font-size: 30px;
                    .activity-end {
                        font-size: 48px;
                        margin: 25px;
                    }
                }

                .time-box-h {
                    display: flex;
                    justify-content: space-between;
                    margin-top: 20px;

                    .time-box-item {
                        width: 40px;
                        height: 40px;
                        text-align: center;
                        line-height: 40px;
                        padding: 10px;
                        font-size: 30px;
                        border-radius: 10px;
                        background: linear-gradient(to bottom, #E20D3D, #FF7B55);
                    }

                    .time-box-icon {
                        font-size: 30px;
                        color: #E20D3D;
                    }
                }
            }
        }
    }

    .goods-info {
        display: flex;
        flex-direction: column;

        .pay-tips {
            display: flex;
            align-items: center;
            margin-left: 60px;
            padding: 10px;
            font-size: 24px;
            color: #39AE17;
            background: linear-gradient(to right, #EFFAEA 60%, #F8F8FA 100%);

            .pay-tips-icon {
                margin-right: 10px;

                img {
                    width: 35px;
                    height: 30px;
                    vertical-align: middle;
                }
            }

            .pay-tips-box {
                height: 25px;
                margin: 0 5px;
                border-right: 2px solid #39AE17;
            }
        }

        .goods-name {
            margin-top: 30px;
            margin-left: 60px;
            font-size: 36px;
        }

        .goods-num {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            margin-top: 30px;
            margin-left: 60px;

            .goods-num-top {
                color: #FA1532;
                font-size: 16px;
                font-weight: 800;

                .goods-num-price {
                    font-size: 28px;
                    margin: 0 3px;
                }
            }

            .goods-num-bottom {
                display: flex;
                justify-content: space-between;
                width: 250px;
                font-size: 20px;
                color: #333333;
                margin-top: 30px;
            }
        }

        .invite-box {
            display: flex;
            align-items: center;
            margin-top: 30px;
            margin-left: 40px;
            padding: 5px 20px;
            font-size: 20px;
            color: #F61730;
            font-weight: 600;
            background: linear-gradient(to right, #FEEEC3, #F8F8FA);

            .box-icon {
                width: 20px;
                height: 20px;
                margin-right: 10px;
                text-align: center;
                line-height: 20px;
                font-size: 14px;
                border-radius: 3px;
                background-color: #F61730;
                color: #ffffff;
            }
        }

        .tag-box {
            display: flex;
            margin-top: 30px;
            margin-left: 60px;

            .goods-tag {
                margin-right: 15px;
                padding: 5px 10px;
                font-size: 20px;
                color: #ffffff;
                background-color: #27B60C;
                border-radius: 5px;
            }
        }

        .team-rule-box {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: 750px;
            height: 120px;
            margin-top: 30px;
            margin-left: 40px;
            padding: 15px 15px 15px 25px;
            background-color: #ffffff;


            span {
                width: 750px;
                font-size: 20px;
                font-weight: 800;
            }

            img {
                width: 750px;
            }
        }

        .teamShop-button {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 600px;
            height: 60px;
            margin: 60px auto 0;
            font-size: 28px;
            font-weight: 800;
            color: #ffffff;
            border-radius: 30px;
            background: linear-gradient(to bottom, #DF0E3D, #F9825F);
            .teamShop-button-text {
                color: #FCE7AB;
                font-size: 48px;
                margin: 0 10px;
            }
        }
        .active-end {
			background: #F4AAA7;
		}
    }
}

.active-notices {
    width: 2000px;
    margin-top: 40px;
    padding: 20px;
    background-color: #ffffff;

    .active-notices-title {
        padding-bottom: 10px;
        border-bottom: 1px solid #ccc;

        span {
            font-size: 28px;
            font-weight: 800;
        }
    }



    .title-icon {
        height: 20px;
        margin-right: 20px;
        border-right: 10px solid #4E6EF3;
    }

    .notices-info {
        margin-top: 10px;
    }
}

@keyframes openQRcode {
    0% {
        transform: scale(0.5);
    }

    100% {
        transform: scale(1);

    }
}

.QRcode-box {
    position: fixed;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);

    .QRcode-box-content {
        animation: openQRcode linear 0.2s;
        position: relative;
        width: 500px;
        height: 700px;

        img {
            width: 500px;
            height: 700px;
        }

        .el-icon-close {
            position: absolute;
            top: 30px;
            right: 30px;
            color: #ffffff;
            transform: scale(4);
        }

        .QRcode-main {
            position: absolute;
            bottom: 150px;
            left: 50%;
            transform: translateX(-50%);
            width: 300px;
            height: 300px;
            border-radius: 50%;
            background-color: #ffffff;
            img {
                width: 300px;
                height: 300px;
                border-radius: 50%;
            }
        }
    }
}
</style>
